import axios from "axios";
import { RequestType } from "./types";

const handleError = (error) => {
	if (!error.response.data)
		return console.error("Unable to reach api endpoint");
	console.error(error.response.data.errorMessages[0]);
};

export const apiRequest = async (
	method: RequestType,
	url: string,
	data = null
) => {
	try {
		const response = await axios({ method, url, data });
		return response.data;
	} catch (error) {
		handleError(error);
	}
};
